import React from 'react';
import './PetDivider.css';

// Subtle horizontal rule with a small voxel pet anchor in the middle.
// Used between major sections on the home page for brand continuity.
export default function PetDivider({ size = 36, className = '' }) {
  return (
    <div className={`pet-divider ${className}`} aria-hidden="true">
      <span className="pet-divider-rule" />
      <img
        src="/branding/petlings-pet-96.png"
        alt=""
        width={size}
        height={size}
        className="pet-divider-art"
      />
      <span className="pet-divider-rule" />
    </div>
  );
}
